import _ from "lodash";

const getApplicableFiltersInfo = ({
  moduleFacets,
  activeTab,
  currentTabFiltersConfig,
}) => {
  const entityTypeInfo = currentTabFiltersConfig[activeTab].entityTypeInfo;

  const filtersInfo = _.map(moduleFacets, moduleFace => {
    const { entityType, levels, attributes } = moduleFace;
    const {
      filterLocale,
      tabDisplayOrder,
      isCheckList,
      excludeBlueprintCourses = false,
    } = entityTypeInfo[entityType];

    const applicableFiltersInfo = {
      filter: entityType,
      key: entityType + " " + activeTab, //here activeTab is added to make filters unique across different tabs
      levels,
      attributes,
      label: filterLocale,
      isCheckList,
      order: tabDisplayOrder,
    };

    if (entityType == "LEARNING_COURSE") {
      applicableFiltersInfo.excludeBlueprintCourses = excludeBlueprintCourses;
    }

    return applicableFiltersInfo;
  });

  return _.sortBy(filtersInfo, ({ order }) => order);
};

export const getApplicableFiltersInfoMemoized = _.memoize(
  getApplicableFiltersInfo,
  ({ activeTab, moduleFacets, currentTabFiltersConfig }) => {
    return JSON.stringify({
      activeTab,
      moduleFacets: _.map(moduleFacets, moduleFacet =>
        _.pick(moduleFacet, ["entityType", "levels", "attributes"])
      ),
      currentTabFiltersConfig: {
        isLearningCourseConfig: currentTabFiltersConfig.isLearningCourseConfig,
      },
    });
  }
);

/**This util will update values such that if there are values having same labels,
 * then out of those values only one will remain and rest are discarded.
 */
